var $ = $ || jQuery;

var Animations = function (  ){

    var _animationBase = function( options, tweenMaxOptions ) {
        this.duration = options.duration || 6.0 ;
        this.steps = options.steps;
        this.base_url = options.base_url;
        this.tweenMaxOptionsDefault = {delay: 0, repeat: -1};
        this.elem = document.getElementById(options.elem);

        this.sequenceList = [];
        this.tweenMaxOptions = tweenMaxOptions || {};
        this.tweenMaxSettings = $.extend( {}, this.tweenMaxOptionsDefault, this.tweenMaxOptions );

        if( !this.duration || !this.steps || !this.base_url || !this.elem ){
            console.info('Parámetros insuficientes. steps, base_url, duration y elem son obligatorios');
            return;
        }

        var duration = this.duration,
            steps = this.steps,
            base_url = this.base_url,
            tweenMaxOptionsDefault = this.tweenMaxOptionsDefault,
            elem = this.elem,
            sequenceList = this.sequenceList,
            tweenMaxSettings = this.tweenMaxSettings,
            tweenMaxOptions = this.tweenMaxOptions;

        for(var i = 0; i < steps ; i++) {
            var url = '',
                numberImage = '';

            if( i < 10 ){
                numberImage = String('00' + i);
            } else if( i >= 10 && i < 100 ){
                numberImage = String('0' + i);
            } else{
                numberImage = String(i);
            }

            url = base_url + "animation" + numberImage + ".png"

            sequenceList.push( url );
        }

        var objAnimation = TweenMax.sequence( elem, sequenceList, duration, tweenMaxSettings );
        objAnimation.pause();

        this.animate = objAnimation;

        return objAnimation;
    };

    _animationBase.prototype.start = function(){
        this.prototype.animate.play();
    };

    _animationBase.prototype.stop = function(){
        this.prototype.animate.paused();
    };

    return{
        animationBase:_animationBase
    }
}();

module.exports = Animations;